module.exports = __webpack_public_path__ + "static/media/report.41477206.svg";